class HttpRequest {
    constructor() {
        this.started = false;
        this.success = false;
        this.failed = false;
    }
}

export default HttpRequest;
